import { createStore, del, get, set } from 'idb-keyval';

import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';

const ASSET_STORE_DATABASE_NAME = 'asset-store';
const ASSETS_OBJECT_STORE_NAME = 'assets';
const CUSTOMER_ASSET_LIST_PERSISTENCE_KEY = 'customer-asset-list';

const assetsStore = createStore(ASSET_STORE_DATABASE_NAME, ASSETS_OBJECT_STORE_NAME);

export const createPersister = (idbValidKey: IDBValidKey = CUSTOMER_ASSET_LIST_PERSISTENCE_KEY): Persister => {
    return {
        persistClient: async (client: PersistedClient) => {
            await set(idbValidKey, client, assetsStore);
        },
        restoreClient: async () => {
            return await get<PersistedClient>(idbValidKey, assetsStore);
        },
        removeClient: async () => {
            await del(idbValidKey, assetsStore);
        },
    };
};
